import { CalendarPreferences } from "@/features/calendar/components/Preferences/CalendarPreferences";
import { Preferences, UUID } from "@/core/types";

import { useProviderProfile } from "../api/queries/useProviderProfile";
import { useUpdateProviderProfile } from "../api/mutations/useUpdateProviderProfile";

type ProviderCalendarPreferencesCardProps = {
  providerId?: UUID;
};

export function ProviderCalendarPreferencesCard({
  providerId,
}: ProviderCalendarPreferencesCardProps) {
  const { data: profileData } = useProviderProfile(providerId);
  const { mutateAsync } = useUpdateProviderProfile(providerId, {
    meta: { component: "ProviderCalendarPreferencesCard" },
  });

  const handleUpdate = (newPreferences: Preferences) =>
    mutateAsync({ data: { preferences: newPreferences }, providerId });

  return <CalendarPreferences onUpdate={handleUpdate} preferences={profileData?.preferences} />;
}
